import React, { Component } from "react";
import { Api } from "../../app-controller.js";
import { format } from "date-fns";

class ModalPCE extends Component {
  render() {
    return (
      <>
        <div>
          <div id="SolicitudPCE">
            <div className="row">
              <div className="col-lg-3">
                <div className="widget100 widget widget-stats bg-gradient-teal m-b-10">
                  <div className="stats-icon stats-icon-lg">
                    <i className="fab fa-lg fa-fw m-r-10 fa-wpforms"></i>
                  </div>
                  <div className="stats-content">
                    <div className="stats-title">Trámite</div>

                    <div className="stats-desc">
                      <h5>{this.props.state.solicitud.accion}</h5>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="widget100 widget widget-stats bg-gradient-yellow m-b-10">
                  <div className="stats-icon stats-icon-lg">
                    <i className="fas fa-lg fa-fw m-r-10 fa-question-circle"></i>
                  </div>
                  <div className="stats-content">
                    <div className="stats-title">Tipo</div>

                    <div className="stats-desc">
                      <h5>{this.props.state.solicitud.tramite}</h5>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="widget100 widget widget-stats bg-gradient-blue m-b-10">
                  <div className="stats-icon stats-icon-lg">
                    <i className="fas fa-lg fa-fw m-r-10 fa-clock"></i>
                  </div>
                  <div className="stats-content">
                    <div className="stats-title">Estado</div>

                    <div className="stats-desc">
                      <h5>{this.props.state.solicitud.estatus}</h5>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="widget100 widget widget-stats bg-gradient-green m-b-10">
                  <div className="stats-icon stats-icon-lg">
                    <i className="fas fa-lg fa-fw m-r-10 fa-calendar-alt"></i>
                  </div>
                  <div className="stats-content">
                    <div className="stats-title">Fecha</div>

                    <div className="stats-desc">
                      <h5>
                        {this.props.state.solicitud.fecha_solicitud !== null
                          ? /*  this.props.state.solicitud.fecha_solicitud
                                    .split("-")
                                    .join("-")
                                    .replaceAll("-", "/") */
                            format(
                              new Date(
                                this.props.state.solicitud.fecha_solicitud
                              ),
                              "dd/MM/yyyy"
                            )
                          : this.props.state.solicitud.fecha_solicitud}
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr></hr>
            <div className="row">
              <fieldset className="col-md-12">
                <legend>Información del exportador</legend>
                <div className="row">
                  <div className="form-group col-md-6">
                    <label>Nombre del exportador</label>
                    <div className="form-control">
                      {this.props.state.solicitud.nombre_exportador}
                    </div>
                  </div>
                  <div className="form-group col-md-6">
                    <label>Código de registro IPSA</label>
                    <div className="form-control">
                      {this.props.state.solicitud.codigo_exportador}
                    </div>
                  </div>
                  <div className="form-group col-md-12">
                    <label>Dirección del exportador</label>
                    <div className="form-control">
                      {this.props.state.solicitud.direccion_exportador}
                    </div>
                  </div>
                </div>
              </fieldset>
              <hr></hr>{" "}
              <fieldset className="col-md-12">
                <legend>Información del fabricante </legend>
                <div className="row">
                  <div className="form-group col-md-6">
                    <label>Razón social del establecimiento fabricante</label>
                    <div className="form-control">
                      {this.props.state.solicitud.nombre_fabricante}
                    </div>
                  </div>
                  <div className="form-group col-md-6">
                    <label>Código de registro de IPSA </label>
                    <div className="form-control">
                      {this.props.state.solicitud.codigo_fabricante}
                    </div>
                  </div>
                  <div className="form-group col-md-12">
                    <label>Dirección</label>
                    <div className="form-control">
                      {this.props.state.solicitud.direccion_fabricante}
                    </div>
                  </div>
                </div>
              </fieldset>
              <hr></hr>
              {this.props.state.solicitud.subproducto_tipo_id !== 4 ? (
                <>
                  <fieldset className="col-md-12">
                    <legend>Información del consignatario</legend>
                    <div className="row">
                      <div className="form-group col-md-6">
                        <label>Nombre del consignatario</label>
                        <div className="form-control">
                          {this.props.state.solicitud.nombre_consignatario}
                        </div>
                      </div>
                      <div className="form-group col-md-6">
                        <label>Dirección del consignatario</label>
                        <div className="form-control">
                          {this.props.state.solicitud.direccion_consignatario}
                        </div>
                      </div>
                    </div>
                  </fieldset>
                  <hr></hr>
                  <fieldset className="col-md-12">
                    <legend>Información del destinatario final</legend>
                    <div className="row">
                      <div className="form-group col-md-6">
                        <label>Nombre del destinatario final</label>
                        <div className="form-control">
                          {this.props.state.solicitud.nombre_destinatario}
                        </div>
                      </div>
                      <div className="form-group col-md-6">
                        <label>Dirección del destinatario final</label>
                        <div className="form-control">
                          {
                            this.props.state.solicitud
                              .direccion_destinatario_final
                          }
                        </div>
                      </div>
                    </div>
                  </fieldset>
                  <hr></hr>
                </>
              ) : (
                <>
                  <fieldset className="col-md-12">
                    <legend>Información del importador</legend>
                    <div className="row">
                      <div className="form-group col-md-6">
                        <label>Nombre del importador</label>
                        <div className="form-control">
                          {this.props.state.solicitud.nombre_importador}
                        </div>
                      </div>
                      <div className="form-group col-md-6">
                        <label>Dirección del importador</label>
                        <div className="form-control">
                          {this.props.state.solicitud.direccion_importador}
                        </div>
                      </div>
                    </div>
                  </fieldset>
                  <hr></hr>
                </>
              )}
              <fieldset className="col-md-12">
                <legend>Información del producto</legend>
                <div className="row">
                  <div className="form-group col-md-12">
                    <label>Descripción del producto</label>
                    <textarea
                      className="form-control"
                      rows="5"
                      name="observaciones"
                      value={this.props.state.solicitud.descripcion_producto}
                      disabled={true}
                    ></textarea>
                  </div>
                  <div className="form-group col-md-6">
                    <label>Nombre comercial</label>
                    <div className="form-control">
                      {this.props.state.solicitud.nombre_comercial_producto}
                    </div>
                  </div>
                  <div className="form-group col-md-6">
                    <label>No. de registro sanitario IPSA</label>
                    <div className="form-control">
                      {"(" + this.props.state.solicitud.no_registro + ")"}
                    </div>
                  </div>
                  {this.props.state.solicitud.subproducto_tipo_id === 4 ? (
                    <div className="form-group col-md-6">
                      <label>Especie de origen</label>
                      <div className="form-control">
                        {this.props.state.solicitud.especie}
                      </div>
                    </div>
                  ) : null}
                  <div className="form-group col-md-6">
                    <label>Presentación</label>
                    <div className="form-control">
                      {this.props.state.solicitud.empaque}(
                      {this.props.state.solicitud.cantidad_empaque}{" "}
                      {this.props.state.solicitud.unidad_medida})
                    </div>
                  </div>
                  <div className="form-group col-md-6">
                    <label>Cantidad</label>
                    <div className="form-control">
                      {this.props.state.solicitud.cantidad}
                    </div>
                  </div>
                  <div className="form-group col-md-6">
                    <label>Peso neto</label>
                    <div className="form-control">
                      {this.props.state.solicitud.peso_neto}
                    </div>
                  </div>
                  <div className="form-group col-md-6">
                    <label>Número de lote</label>
                    <div className="form-control">
                      {this.props.state.solicitud.no_lote}
                    </div>
                  </div>
                  <div className="form-group col-md-6">
                    <label>Código de producción</label>
                    <div className="form-control">
                      {this.props.state.solicitud.codigo_produccion}
                    </div>
                  </div>
                </div>
              </fieldset>
              <hr></hr>
              <fieldset className="col-md-12">
                <legend>Información del medio de transporte</legend>
                <div className="row">
                  <div className="form-group col-md-6">
                    <label>Número de contenedor</label>
                    <div className="form-control">
                      {this.props.state.solicitud.numero_contenedor}
                    </div>
                  </div>
                  {/* {(this.props.state.solicitud.numero_marchamo !== null)?
                  <div className="form-group col-md-6">
                    <label>Número de marchamo(precinto)</label>
                    <div className="form-control">
                      {this.props.state.solicitud.numero_marchamo}
                    </div>
                  </div>
                  : null} */}
                  <div className="form-group col-md-6">
                    <label>Puerto de salida</label>
                    <div className="form-control">
                      {this.props.state.solicitud.puerto_salida}
                    </div>
                  </div>
                  <div className="form-group col-md-6">
                    <label>Puerto de entrada</label>
                    <div className="form-control">
                      {this.props.state.solicitud.puerto_entrada}
                    </div>
                  </div>
                  <div className="form-group col-md-6">
                    <label>Fecha de embarque</label>
                    <div className="form-control">
                      {this.props.state.solicitud.fecha_embarque}
                    </div>
                  </div>
                  <div className="form-group col-md-6">
                    <label>Compañia transportadora</label>
                    <div className="form-control">
                      {this.props.state.solicitud.compania_transportadora}
                    </div>
                  </div>
                  <div className="form-group col-md-6">
                    <label>Medio de transporte</label>
                    <div className="form-control">
                      {this.props.state.solicitud.tipo_vehiculo}
                    </div>
                  </div>
                  <div className="form-group col-md-6">
                    <label>Identificación del medio de transporte</label>
                    <div className="form-control">
                      {
                        this.props.state.solicitud
                          .identificacion_medio_transporte
                      }
                    </div>
                  </div>
                </div>
              </fieldset>
              <hr></hr>
              <div
                className={
                  this.props.state.solicitud.documentos.length
                    ? "col-md-12"
                    : "hide"
                }
              >
                <hr></hr>
                <fieldset className="col-md-12">
                  <legend>Documentación</legend>
                  <div className="table-responsive">
                    <button
                      className="btn btn-primary pull-right"
                      id="descarga_docs_pce"
                      onClick={this.props.component.handleDownloadZipPCE}
                    >
                      Descargar selección
                    </button>
                    <table className="table table-striped m-b-0 table-hover">
                      <thead>
                        <tr>
                          <th width="50">
                            <div className="checkbox checkbox-inline checkbox-css">
                              <input
                                onChange={(e) =>
                                  this.props.component.allDocsSol(e)
                                }
                                type="checkbox"
                                value={this.props.state.allDocs || false}
                                name="allc_e"
                                checked={this.props.state.allDocs || false}
                                id="allc_e"
                              />
                              <label htmlFor="allc_e">Todos</label>
                            </div>
                          </th>
                          <th className="text-center">Vista previa</th>
                          <th className="text-center">Documento</th>
                          <th className="text-center">Fecha carga</th>
                          <th className="text-center">Estado</th>
                          <th className="text-center">
                            Fecha aprobación medico veterinario
                          </th>
                          <th className="text-center">Acción</th>
                        </tr>
                      </thead>
                      <tbody
                        className={this.props.state.working ? "hide" : "show"}
                      >
                        {this.props.state.documentos.map((sol) => (
                          <tr key={sol.id}>
                            <td className="text-center">
                              <div className="checkbox checkbox-inline checkbox-css">
                                <input
                                  type="checkbox"
                                  className="checkbox_pce"
                                  id={sol.id}
                                  onChange={(e) => {
                                    this.props.component.handleSolicitudChecks(
                                      e
                                    );
                                  }}
                                  name={sol.id}
                                  value={
                                    this.props.state.solicitudDocsCheck[
                                      sol.id
                                    ] || false
                                  }
                                  checked={
                                    this.props.state.solicitudDocsCheck[
                                      sol.id
                                    ] || false
                                  }
                                />
                                <label htmlFor={sol.id}></label>
                              </div>
                            </td>
                            <td className="text-center">
                              <img
                                alt="Vista previa"
                                className="rounded btn vista-previa"
                                data-id={sol.id}
                                onClick={this.props.component.handlePrevia}
                                width="60"
                                src={
                                  Api.url +
                                  `app/vistapreviaPCE/?id=${sol.id}&thumb=1`
                                }
                              />
                            </td>
                            <td className="text-center">{sol.documento}</td>
                            <td align="center">
                              {sol.fecha_solicitud !== null
                                ? format(
                                    new Date(sol.fecha_solicitud),
                                    "dd/MM/yyyy"
                                  )
                                : ""}
                            </td>

                            <td className="text-center pce-doc-status">
                              {sol.estatus_documento}
                            </td>

                            <td align="center">
                              {sol.fecha_aprobado !== null
                                ? format(
                                    new Date(sol.fecha_aprobado),
                                    "dd/MM/yyyy"
                                  )
                                : ""}
                            </td>

                            <td className="text-center">
                              <div className="btn-group">
                                <a
                                  href={
                                    Api.url +
                                    `app/vistapreviaPCE/?id=${sol.id}&download=1`
                                  }
                                  className="btn btn-primary"
                                >
                                  <i className="fas fa-file-download"></i>
                                </a>
                                <button
                                  className={
                                    sol.estatus_documento_id !== "1" ||
                                    sol.estatus_tramite_id !== "1"
                                      ? "blockea btn btn-danger "
                                      : "btn btn-danger documento-rechazar"
                                  }
                                  data-subproducto_id={
                                    sol.rel_subproducto_producto_id
                                  }
                                  data-solicitud_estatus={
                                    sol.estatus_documento_id
                                  }
                                  id={sol.id}
                                  onClick={
                                    this.props.component
                                      .handlesolicitudDocumentoStatus
                                  }
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  name="Rechazar"
                                  disabled={
                                    sol.estatus_documento_id !== "1" ||
                                    sol.estatus_tramite_id !== "1"
                                      ? true
                                      : false
                                  }
                                  data-name="Rechazar"
                                >
                                  <i
                                    className="fas fa-ban documento-rechazar"
                                    data-subproducto_id={
                                      sol.rel_subproducto_producto_id
                                    }
                                    data-solicitud_estatus={
                                      sol.estatus_documento_id
                                    }
                                    id={sol.id}
                                    onClick={
                                      this.props.component
                                        .handlesolicitudDocumentoStatus
                                    }
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    data-name="Rechazar"
                                    disabled={
                                      sol.estatus_documento_id !== "1" ||
                                      sol.estatus_tramite_id !== "1"
                                        ? true
                                        : false
                                    }
                                  ></i>
                                  Rechazar
                                </button>
                                <button
                                  className={
                                    sol.estatus_documento_id !== "1" ||
                                    sol.estatus_tramite_id !== "1"
                                      ? "blockea btn btn-success "
                                      : "btn btn-success documento-aceptar"
                                  }
                                  data-subproducto_id={
                                    sol.rel_subproducto_producto_id
                                  }
                                  data-solicitud_estatus={
                                    sol.estatus_documento_id
                                  }
                                  id={sol.id}
                                  onClick={
                                    this.props.component
                                      .handlesolicitudDocumentoStatus
                                  }
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  data-name="Aprobar"
                                  disabled={
                                    sol.estatus_documento_id !== "1" ||
                                    sol.estatus_tramite_id !== "1"
                                      ? true
                                      : false
                                  }
                                >
                                  <i
                                    className="fas fa-check  documento-aceptar"
                                    onClick={
                                      this.props.component
                                        .handlesolicitudDocumentoStatus
                                    }
                                    data-subproducto_id={
                                      sol.rel_subproducto_producto_id
                                    }
                                    data-solicitud_estatus={
                                      sol.estatus_documento_id
                                    }
                                    id={sol.id}
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    data-name="Aprobar"
                                    disabled={
                                      sol.estatus_documento_id !== "1" ||
                                      sol.estatus_tramite_id !== "1"
                                        ? true
                                        : false
                                    }
                                  ></i>
                                  Aprobar
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </fieldset>
                <hr></hr>
                <div className="row">
                  <fieldset className="col-md-12">
                    <legend>
                      Número marchamo <span className="text-danger"> *</span>{" "}
                    </legend>
                    <div className="row">
                      <div className="col-lg-10">
                        <div className="form-group">
                          <label>Número de marchamo: </label>
                          <input
                            type="text"
                            value={this.props.state.no_marchamo}
                            name="no_marchamo_pce"
                            maxLength={30}
                            onChange={(e) =>
                              this.props.component.handleChangeMarchamo(e)
                            }
                            className="form-control"
                            id="numero_marchamo"
                            title="Número de marchamo"
                            placeholder="Número de marchamo"
                          />
                        </div>
                      </div>
                      <div className="col-md-2" style={{ marginTop: "1.5em" }}>
                        <button
                          type="button"
                          className="btn btn-info col-md-12"
                          name="no_marchamo_pce"
                          onClick={this.props.component.addMarchamo}
                          disabled = {this.props.state.solicitud.estatus_tramite_id ===
                            "1" || this.props.state.solicitud.estatus_tramite_id ===
                            "5"
                              ? false
                              : true}
                        >
                          +
                        </button>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <table className="table table-striped m-b-0 table-hover">
                          <thead>
                            <tr>
                              <th>Número marchamo</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.props.state.lista_marchamos.length > 0
                              ? this.props.state.lista_marchamos.map(
                                  (reg, index) => (
                                    <tr key={index} id={"t" + index}>
                                      <td>{reg.numero_marchamo}</td>
                                      <td
                                       className={
                                        this.props.state.solicitud
                                          .estatus_tramite_id === "1"
                                          ? ""
                                          : "hide"
                                      }>
                                        <button
                                          id={index}
                                          onClick={
                                            this.props.component.removeMarchamo
                                          }
                                          className="btn btn-warning pull-right"
                                        >
                                          <i
                                            id={index}
                                            onClick={
                                              this.props.component
                                                .removeMarchamo
                                            }
                                            className="fas fa-trash"
                                          ></i>
                                        </button>
                                      </td>
                                    </tr>
                                  )
                                )
                              : ""}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </fieldset>
                </div>

                <hr></hr>
                <fieldset className="panel">
                  <legend>
                    Leyenda
                    <span className="text-danger"> *</span>{" "}
                  </legend>
                  <div className="container">
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="form-group">
                          <textarea
                            className="form-control"
                            placeholder="Leyenda (5000)"
                            maxLength={5000}
                            rows="5"
                            name="leyenda"
                            value={this.props.state.solicitud.leyenda}
                            onChange={(e) =>
                              this.props.component.handleLeyendaChange(e)
                            }
                            disabled={
                              this.props.state.solicitud.estatus_tramite_id !==
                              "1"
                                ? true
                                : false
                            }
                            required
                          ></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                </fieldset>
                <hr></hr>
                <fieldset className="panel">
                  <legend>
                    Observaciones acerca del precertificado
                    <span className="text-danger"> *</span>{" "}
                  </legend>
                  <div className="container">
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="form-group">
                          <textarea
                            className="form-control"
                            placeholder="Observaciones acerca del precertificado (500)"
                            maxLength={500}
                            rows="5"
                            name="observaciones_pce"
                            value={this.props.state.solicitud.observaciones}
                            onChange={(e) =>
                              this.props.component.handleObservacionChange(e)
                            }
                            disabled={
                              this.props.state.solicitud.estatus_tramite_id !==
                              "1"
                                ? true
                                : false
                            }
                            required
                          ></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                </fieldset>
                <hr></hr>
              </div>
              <div className="col-md-12">
                <div className="btn-group pull-left col-md-4">
                  <button
                    onClick={this.props.component.handlePrecertificadoCEStatus}
                    value="4"
                    id="rechazar_pce"
                    className="btn btn-danger"
                    //disabled={this.props.state.certificado.aprobado==="5" || this.props.state.certificado.aprobado==="4"? true: false}
                  >
                    Rechazar
                  </button>
                </div>
                <div className="btn-group pull-right col-md-4">
                  {/*    <button id="regresar_mv" className="btn btn-white ">
                            Regresar
                          </button> */}
                  <button
                    onClick={this.props.component.handlePrecertificadoCEStatus}
                    value="5"
                    id="aprobar_pce"
                    className="btn btn-success"
                    //disabled={this.props.state.certificado.aprobado==="5" || this.props.state.certificado.aprobado==="4"? true: false}
                  >
                    Aceptar
                  </button>
                </div>
              </div>
              <div className={this.props.state.previa ? "previa" : "hide"}>
                <iframe
                  title="Vista previa"
                  className="rounded"
                  src={this.props.state.previa_url}
                ></iframe>
                <center>
                  <div className="btn-group">
                    <button
                      onClick={() => {
                        this.props.component.handlePreviaClose();
                      }}
                      className="btn btn-danger"
                    >
                      Regresar
                    </button>
                    <a
                      className="btn btn-primary"
                      href={this.props.state.previa_url + "&download=1"}
                      download="download"
                    >
                      Descargar
                    </a>
                  </div>
                </center>
              </div>
            </div>
          </div>
        </div>
        {/* </div>
          </div>
        </div> */}
      </>
    );
  }
}

export default ModalPCE;
